import React, { useState } from 'react'
import {Form, Formik} from "formik";
import { Container, Button } from 'reactstrap';
import {onboard_steps_path, onboard_step_path, prepare_subscribe_portal_path} from '../../../routes';
import companyNameSchema from "./companyNameSchema";
import FormCompanyName from '../../forms/formCompanyName';
import './step_one.scss'

const StepOne = ({company_name, company_id}) => {
  const params = new URLSearchParams(document.location.search);
  const subPlanId = params.get('sub_plan_id')
  const stripe = Stripe('pk_test_51JxnEXIOA6oHmCDBcom3on0XzlyeBpu3mBOTGOJPTEaKQLjhzYca5y6HnWvjSlvPkDEA2XZFcZ87RoQ7oe5GPpC3005p2RualL');
  const [company, setCompany] = useState({
    id: company_id,
    name: company_name,
  })

  const INITIAL_VALUES = {
    company_name: company.name || ''
  }

  const stripeSessionPortalhandler = async () => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({subPlanId: subPlanId,})
    };
    const resp = await fetch(prepare_subscribe_portal_path({format: 'json'}), requestOptions)
    if (resp.ok) {
      const data = await resp.json();
      stripe.redirectToCheckout({sessionId: data.session_id})
    }
  }

  const handleSubmit = (values, { setFieldError }) => {
    const { company_name } = values
    setCompany((prevState) => ({...prevState, name: company_name}))
    const submitValues = {
      id: 2,
      company_name,
      sub_plan_id: subPlanId
    }

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(submitValues)
    };

    fetch(onboard_steps_path({format: 'json'}), requestOptions)
    .then(async response => {
      const data = await response.json()
      if (response.ok) {
        if (typeof company.id !== 'number') {
          setCompany((prevState) => ({...prevState, id: data.company.id}))
        }
        if (subPlanId) {
          stripe_response = await stripeSessionPortalhandler()
        } else {
          window.location = onboard_step_path(3)
        }
      } else {
        const nameError = (data && data.company)

        if (nameError) {
          setFieldError('company_name', <span>{nameError} Please try another name or <a href='mailto:contact@hubbleiq.com'>Contact us!</a> for help</span>)
        }

        return Promise.reject(nameError)
      }
    })
    .catch(error => {
        console.log('ERROR!', error)
    })
  }

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={INITIAL_VALUES}
      validationSchema={companyNameSchema()}
    >
      {({handleSubmit, isValid, values}) => (
        <div className="page-onboarding">
          <section className="content">
            <Container>
              <Form onSubmit={handleSubmit} className="form form-company-name">
                <div className="content-layout">
                  <div className="page-onboarding-text">
                  <div className="page-onboarding-title">Company name</div>
                  <div className="page-onboarding-subtitle">What name should we give your system?</div>
                  </div>
                  <div className="page-onboarding-aside">
                    <FormCompanyName name="company_name" placeholder="Enter company name" />
                    <div className="page-onboarding-buttons">
                      <Button
                        className="button button-default mt-3"
                        generaltype="default"
                        disabled={!isValid || !values.company_name}
                      >
                        {subPlanId ? 'Continue to Payment' : 'Continue'}
                      </Button>
                    </div>
                  </div>
                  
                </div>
              </Form>
            </Container>
          </section>
        </div>
      )}
    </Formik>
  )
}

export default StepOne
